import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import {
  projectListReducer,
  projectDetailsReducer,
  projectCreateReducer,
  projectUpdateReducer,
  projectDeleteReducer,
} from "./reducers/projectReducer"; // your project reducers
import {
  postListReducer,
  postCreateReducer,
  postUpdateReducer,
  postDeleteReducer,
  postDetailsReducer,
} from "./reducers/postReducer";
import { userLoginReducer, userRegisterReducer } from "./reducers/authReducer";
import { adminDataReducer } from "./reducers/adminReducer";
import {
  developerCreateReducer,
  developerUpdateReducer,
  developerDeleteReducer,
  developerDetailsReducer,
} from "./reducers/developerReducers";

// 1) Load userInfo from localStorage if it exists
let userInfoFromStorage = null;
if (localStorage.getItem("userInfo")) {
  userInfoFromStorage = JSON.parse(localStorage.getItem("userInfo"));
}

// 2) Construct initialState with userLogin slice
const initialState = {
  userLogin: {
    userInfo: userInfoFromStorage,
  },
};

// 3) Combine all reducers
const rootReducer = combineReducers({
  // Auth/Users
  userLogin: userLoginReducer, // Replaces your custom userReducer
  userRegister: userRegisterReducer,

  // Projects
  projectList: projectListReducer,
  projectDetails: projectDetailsReducer,
  projectCreate: projectCreateReducer,
  projectUpdate: projectUpdateReducer,
  projectDelete: projectDeleteReducer,

  // Posts
  postList: postListReducer,
  postCreate: postCreateReducer,
  postUpdate: postUpdateReducer,
  postDelete: postDeleteReducer,
  postDetails: postDetailsReducer,

  // Developers
  developerCreate: developerCreateReducer,
  developerUpdate: developerUpdateReducer,
  developerDelete: developerDeleteReducer,
  developerDetails: developerDetailsReducer,

  // Admin
  adminData: adminDataReducer,
});

// 4) Add thunk middleware
const middleware = [thunk];

// 5) Create store with initialState + dev tools
const store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
